import { axiosInstance } from "../axios";
import { AzureTokenExchangeResponse, Login, MeResponse, Token } from "./user.types";

export const loginUser = (data: Login) => {
    return axiosInstance.request<Token>({
        method: "POST",
        url: "/login",
        data,
    });
};

// azureAccessToken is the raw Microsoft-issued token (e.g. from acquireTokenSilent) —
// sent as-is so the backend can validate it via the AzureAd/ExternalEntraId scheme.
export const exchangeAzureToken = (azureAccessToken: string) => {
    return axiosInstance.request<AzureTokenExchangeResponse>({
        method: "POST",
        url: "/auth/azure/token",
        headers: {
            Authorization: `Bearer ${azureAccessToken}`,
        },
    });
};

export const getMe = () => {
    return axiosInstance.request<MeResponse>({
        method: "GET",
        url: "/me",
    });
};
